/*
 * Copia di `PRIMENG_IT_TRANSLATION` di @arpes-is/angular-20-ui@1.0.0-alpha.8.
 * Da sostituire con la libreria quando avrà una versione compatibile con Angular 21.
 */
import type { Translation } from 'primeng/api';

/**
 * Traduzione italiana di PrimeNG.
 * Copre sia le etichette visibili sia le stringhe ARIA usate dai componenti
 * (chiusura overlay, paginazione, selezione righe, ecc.), così che le
 * tecnologie assistive ricevano testi nella lingua della pagina (WCAG 3.1.1 / 3.1.2).
 */
export const PRIMENG_IT_TRANSLATION: Translation = {
    startsWith: 'Inizia con',
    contains: 'Contiene',
    notContains: 'Non contiene',
    endsWith: 'Finisce con',
    equals: 'Uguale a',
    notEquals: 'Diverso da',
    noFilter: 'Nessun filtro',
    lt: 'Minore di',
    lte: 'Minore o uguale a',
    gt: 'Maggiore di',
    gte: 'Maggiore o uguale a',
    is: 'È',
    isNot: 'Non è',
    before: 'Prima di',
    after: 'Dopo',
    dateIs: 'La data è',
    dateIsNot: 'La data non è',
    dateBefore: 'La data è precedente a',
    dateAfter: 'La data è successiva a',
    clear: 'Cancella',
    apply: 'Applica',
    matchAll: 'Tutte le condizioni',
    matchAny: 'Almeno una condizione',
    addRule: 'Aggiungi regola',
    removeRule: 'Rimuovi regola',
    accept: 'Sì',
    reject: 'No',
    choose: 'Scegli',
    upload: 'Carica',
    cancel: 'Annulla',
    completed: 'Completato',
    pending: 'In attesa',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
    monthNames: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre',
    ],
    monthNamesShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
    dateFormat: 'dd/mm/yy',
    firstDayOfWeek: 1,
    today: 'Oggi',
    weekHeader: 'Sett.',
    weak: 'Debole',
    medium: 'Media',
    strong: 'Forte',
    passwordPrompt: 'Inserisci una password',
    emptyMessage: 'Nessun risultato trovato',
    emptyFilterMessage: 'Nessun risultato trovato',
    emptySearchMessage: 'Nessun risultato trovato',
    emptySelectionMessage: 'Nessun elemento selezionato',
    selectionMessage: '{0} elementi selezionati',
    searchMessage: '{0} risultati disponibili',
    fileChosenMessage: '{0} file',
    noFileChosenMessage: 'Nessun file selezionato',
    chooseYear: 'Scegli anno',
    chooseMonth: 'Scegli mese',
    chooseDate: 'Scegli data',
    prevDecade: 'Decennio precedente',
    nextDecade: 'Decennio successivo',
    prevYear: 'Anno precedente',
    nextYear: 'Anno successivo',
    prevMonth: 'Mese precedente',
    nextMonth: 'Mese successivo',
    prevHour: 'Ora precedente',
    nextHour: 'Ora successiva',
    prevMinute: 'Minuto precedente',
    nextMinute: 'Minuto successivo',
    prevSecond: 'Secondo precedente',
    nextSecond: 'Secondo successivo',
    am: 'AM',
    pm: 'PM',
    aria: {
        trueLabel: 'Vero',
        falseLabel: 'Falso',
        nullLabel: 'Non selezionato',
        star: '1 stella',
        stars: '{star} stelle',
        selectAll: 'Seleziona tutti gli elementi',
        unselectAll: 'Deseleziona tutti gli elementi',
        close: 'Chiudi',
        previous: 'Precedente',
        next: 'Successivo',
        navigation: 'Navigazione',
        scrollTop: 'Torna in alto',
        moveTop: 'Sposta in cima',
        moveUp: 'Sposta su',
        moveDown: 'Sposta giù',
        moveBottom: 'Sposta in fondo',
        moveToTarget: 'Sposta nella destinazione',
        moveToSource: 'Sposta nella sorgente',
        moveAllToTarget: 'Sposta tutto nella destinazione',
        moveAllToSource: 'Sposta tutto nella sorgente',
        pageLabel: 'Pagina {page}',
        firstPageLabel: 'Prima pagina',
        lastPageLabel: 'Ultima pagina',
        nextPageLabel: 'Pagina successiva',
        prevPageLabel: 'Pagina precedente',
        previousPageLabel: 'Pagina precedente',
        rowsPerPageLabel: 'Righe per pagina',
        jumpToPageDropdownLabel: 'Vai alla pagina',
        jumpToPageInputLabel: 'Vai alla pagina',
        selectRow: 'Riga selezionata',
        unselectRow: 'Riga deselezionata',
        expandRow: 'Riga espansa',
        collapseRow: 'Riga compressa',
        showFilterMenu: 'Mostra menu filtri',
        hideFilterMenu: 'Nascondi menu filtri',
        filterOperator: 'Operatore filtro',
        filterConstraint: 'Condizione filtro',
        editRow: 'Modifica riga',
        saveEdit: 'Salva modifica',
        cancelEdit: 'Annulla modifica',
        listView: 'Vista elenco',
        gridView: 'Vista griglia',
        slide: 'Diapositiva',
        slideNumber: 'Diapositiva {slideNumber}',
        zoomImage: 'Ingrandisci immagine',
        zoomIn: 'Aumenta zoom',
        zoomOut: 'Riduci zoom',
        rotateRight: 'Ruota a destra',
        rotateLeft: 'Ruota a sinistra',
        listLabel: 'Elenco opzioni',
        selectColor: 'Seleziona colore',
        removeLabel: 'Rimuovi',
        browseFiles: 'Sfoglia file',
        maximizeLabel: 'Massimizza',
        minimizeLabel: 'Minimizza',
    },
};
